import styled from '@emotion/styled'
import { Popover } from 'antd'

type ExampleLabelPropsType = {
	exampleImg?: string
}
const ExampleLabel = ({ exampleImg }: ExampleLabelPropsType) => {
	return (
		<Label
			placement="rightTop"
			arrow={false}
			content={
				<ExampleImgBlock>
					<ExampleImg src={exampleImg} />
				</ExampleImgBlock>
			}
		>
			예시 보기
		</Label>
	)
}

const Label = styled(Popover)`
	width: fit-content;
	background-color: #4e4e4e;
	color: #fff;
	font-family: 'Pretendard';
	font-size: 1.3rem;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	letter-spacing: 0.2px;
	padding: 0.5rem 1rem;
	border-radius: 0.6rem;
	text-align: center;
`

const ExampleImgBlock = styled.div`
	width: 25.3rem;
	height: 19.5rem;
`
const ExampleImg = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`

export default ExampleLabel
